import * as React from 'react';
import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive' | 'warning' | 'info' | 'success';
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalS),
    borderRadius: tokens.borderRadiusMedium,
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
  },
  destructive: { backgroundColor: tokens.colorPaletteRedBackground2, color: tokens.colorPaletteRedForeground2 },
  warning: { backgroundColor: tokens.colorPaletteYellowBackground2, color: tokens.colorPaletteYellowForeground2 },
  info: { backgroundColor: tokens.colorPaletteBlueBackground2, color: tokens.colorPaletteBlueForeground2 },
  success: { backgroundColor: tokens.colorPaletteGreenBackground2, color: tokens.colorPaletteGreenForeground2 },
});

export const Alert: React.FC<React.PropsWithChildren<AlertProps>> = ({ children, variant = 'default', className, ...rest }) => {
  const styles = useStyles();
  const variantClass =
    variant === 'destructive' ? styles.destructive :
    variant === 'warning' ? styles.warning :
    variant === 'info' ? styles.info :
    variant === 'success' ? styles.success : undefined;
  return (
    <div role="alert" className={[styles.root, variantClass, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
};

export const AlertDescription: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...rest }) => (
  <div {...rest}>{children}</div>
);


